import { Button, CircularProgress, Grid, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Colors } from 'src/shared/components/styles';
import { ProjectStatusEnum } from 'src/shared/enums/projectStatus.enum';
import { isSustainabilityReporterUserOrAdmin } from 'src/shared/helpers/permissionHelper';
import { SustainabilityReportResponse } from 'src/shared/services/api/response/sustainabilityReportResponse';
import { RootStateType } from 'src/shared/services/redux/reducers';

type SustainabilitySubmitButtonProps = {
  status: number;
  disabled: boolean;
  report: SustainabilityReportResponse;
  updateDisabled: boolean;
  showDisabledTooltip: boolean;
  onClickDelete: () => void;
  onClickUpdate: () => void;
};

export const SustainabilitySubmitButton = (
  props: SustainabilitySubmitButtonProps,
) => {
  const {
    status,
    disabled,
    updateDisabled,
    showDisabledTooltip,
    onClickDelete,
    onClickUpdate,
    report,
  } = props;
  const { t } = useTranslation();
  const { userDetails } = useSelector(
    (state: RootStateType) => state.authState,
  );
  // const isSuperAdmin =
  //   userDetails?.permissionGroup.id === UserTypeEnum.SuperAdmin;
  return (
    <>
      {(status === ProjectStatusEnum.Created ||
        status === ProjectStatusEnum.SupplementRequested) && (
        <Grid
          item
          xs={12}
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          p={2}
        >
          <Tooltip title={`${t('canOnlyBeUsedBySuperAdmin')}`} arrow>
            <span>
              <Button
                variant='outlined'
                color='warning'
                disabled={
                  !isSustainabilityReporterUserOrAdmin(userDetails, report)
                } // Bara SuperAdmin får radera en rapport just nu
                onClick={onClickDelete}
              >
                {t('Delete')}
              </Button>
            </span>
          </Tooltip>
          <Tooltip
            title={
              updateDisabled
                ? `${t('noPermissionToEditReport')}`
                : `${t('onlyContentUpdate')}`
            }
            arrow
          >
            <span>
              <Button
                variant='outlined'
                type='button'
                disabled={updateDisabled}
                onClick={() => onClickUpdate()}
              >
                {t('saveChanges')}
              </Button>
            </span>
          </Tooltip>
          <Tooltip
            title={
              showDisabledTooltip
                ? `${t('noPermissionToFinalizeReport')}`
                : `${t('emailToResponsibleReviewer')}`
            }
            arrow
          >
            <span>
              <Button
                variant='contained'
                sx={{
                  fontSize: 12,
                  backgroundColor: Colors.BADGE_YELLOW,
                  color: 'text.primary',
                  ':hover': {
                    backgroundColor: Colors.BADGE_YELLOW,
                    color: 'text.primary',
                  },
                }}
                type='submit'
                disabled={disabled}
                startIcon={
                  disabled ? (
                    <CircularProgress size={16} color='inherit' />
                  ) : undefined
                }
              >
                {t('markAsReadyForApproval')}
              </Button>
            </span>
          </Tooltip>
        </Grid>
      )}
    </>
  );
};
